import { render } from "./TechInfoVariant.vue?vue&type=template&id=0ad77e1f"
import script from "./TechInfoVariant.vue?vue&type=script&lang=js"
export * from "./TechInfoVariant.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__